enum TransactionType {
  SELL = 'sell',
  BUY = 'buy',
  MERCHANT = 'merchant'
}

export default TransactionType;
